import { Typography } from '@components/typography';
import { SparklesCore } from '@components/ui/sparkles';

export function Card({
  title,
  description,
  icon,
  image,
  imagePosition = 'center',
}: {
  title: string;
  description: string;
  icon?: React.ReactNode;
  image: string;
  imagePosition?: 'center' | 'top' | 'bottom';
}) {
  const objectPosition = `left ${imagePosition}`;

  return (
    <div className="bg-white cursor-default overflow-hidden shadow-lg border-1 p-4 lg:pb-5 px-0 pt-0 flex flex-col overflow-hidden w-full lg:grow h-fit lg:h-[380px] rounded-lg gap-4">
      <img
        loading="lazy"
        className="w-full object-cover overflow-hidden object-bottom!"
        style={{ objectPosition, aspectRatio: 350 / 200 }}
        src={image}
        alt={title}
      />
      <div className="flex flex-col gap-2 px-4 lg:px-6">
        <div className="flex items-center gap-0">
          <Typography variant="subtitle">{icon}</Typography>
          <Typography variant="subtitle">{title}</Typography>
        </div>
        <Typography variant="small">{description}</Typography>
      </div>
    </div>
  );
}

export function CardIcon({
  title,
  description,
  icon,
  iconImg,
}: {
  title: string;
  description: string;
  icon?: React.ReactNode;
  iconImg: React.ReactNode;
}) {
  return (
    <div className="bg-white cursor-default overflow-hidden shadow-lg border-1 p-4 lg:pb-5 px-0 pt-0 flex flex-col overflow-hidden w-full lg:grow h-fit lg:h-[380px] rounded-lg gap-4">
      <div
        className="relative w-full h-full bg-black flex items-center justify-center"
        style={{ aspectRatio: 350 / 200 }}
      >
        <div className="w-full absolute inset-0 h-full">
          <SparklesCore
            background="transparent"
            minSize={0.6}
            maxSize={1.4}
            particleDensity={100}
            className="w-full h-full"
            particleColor="#FFFFFF"
          />
        </div>

        {iconImg}
      </div>
      <div className="flex flex-col gap-2 px-4 lg:px-6">
        <div className="flex items-center gap-0">
          <Typography variant="subtitle">{icon}</Typography>
          <Typography variant="subtitle">{title}</Typography>
        </div>
        <Typography variant="small">{description}</Typography>
      </div>
    </div>
  );
}
